import React, { Component } from 'react';
import { connect } from 'react-redux';
import enhanceWithClickOutside from 'react-click-outside';
import { imgError } from '../utils/utils';
import ChangeLanguageModal from './modals/changeLanguage';
import EditPersonalDetailsModal from './modals/editPersonalDetails';
import EditPanelModal from './modals/editPanel';
import EditRedirectModal from './modals/editRedirect';
import ChangePassword from './modals/ChangePassword';
import noAvatar from '../assets/img/no-avatar.png';
import "../agent/Styles/darktheme.css";
import "../agent/Styles/blacktheme.css";
import "../agent/Styles/highContrast.css";
import ThemeModal from './modals/ThemeModal';
import AudioSettingsModal from './modals/AudioSettingsModal';


const ESCAPE_KEY = 27;

class UserMenu extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isShow: false,
			showModal: false,
			showEditDetailsModal: false,
			showRedirectionModal: false,
			showPanelSetupModal: false,
			showAudioSettingsModal: false,
		};
		this.handleClick = this.handleClick.bind(this);
	}
	componentWillMount() {
		document.addEventListener("keydown", this.handleKeyDown);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.closeMenu !== this.props.closeMenu && this.state.isShow) {
			this.handleClickOutside();
		}
	}

	componentWillUnmount() {
		document.removeEventListener("keydown", this.handleKeyDown);
	}

	handleKeyDown = (event) => {
		switch (event.keyCode) {
			case ESCAPE_KEY:
				this.handleClickOutside();
				break;
			default:
				break;
		}
	}
	close = (key) => {
		this.setState({ [key]: false });
	}

	open = (key) => {
		this.setState({ [key]: true });
	}

	handleClickOutside = () => {
		if (this.state.isShow) {
			this.setState({
				isShow: !this.state.isShow
			})
		}
	}

	handleClick(event) {
		if(event.target && (event.target.id === "profile-extension" || 
		event.target.id === "profile-pic" || 
		event.target.id === "profile-section") || 
		(event.target.children[1] && event.target.children[1].id === "profile-extension")) {
			event.preventDefault()  
			this.setState(function (prevState) {
				return { isShow: !prevState.isShow };
			});
		} else {
			this.setState({
				isShow: false
			})
		}
	}

	handleLogout = () => {
		this.props.logout();
	}

	render() {
		const { translations, selectedLanguage, agentInfo } = this.props;
		return (
			<li className={this.state.isShow ? 'user-icon flex-container open' : 'user-icon flex-container'} onClick={(event) => this.handleClick(event)}>
				<a href={undefined} id="profile-section" className="dropdown-toggle flex-container" data-toggle="dropdown" role="button"
						aria-haspopup="true" aria-expanded={this.state.isShow ? 'true' : 'false'}>
					<img
						id="profile-pic"
						className="pull-left"
						src={agentInfo.avatar || noAvatar}
						onError={imgError}
						alt={agentInfo.name}
					/>
					<div style={{ whiteSpace: "nowrap", width: 'auto' }}>
						{`${agentInfo.name} ${agentInfo.surname_1}`}
						<br />
						<span id="profile-extension" style={{ fontSize: 11 }}>
							{`${translations.extensionText[selectedLanguage]} ${agentInfo.extension}`}
						</span>	
					</div>
				</a>
				<ul className={`dropdown-menu dropdown-menu${this.props.theme} profile-dropdown`}>
				    <li><a href={undefined} onClick={() => this.open('showRedirectionModal')}>{translations.callForwardingAndVoiceMail[selectedLanguage]}</a></li>
					<li><a href={undefined} data-toggle="modal" onClick={() => this.open('showPanelSetupModal')} data-target="#viewModal">{translations.pageLayout[selectedLanguage]}</a></li>
					<li><a href={undefined} data-toggle="modal" onClick={() => this.open('showModal')} data-target="#langsModal">{translations.language[selectedLanguage]}</a></li>
					<li><a href={undefined} data-toggle="modal" onClick={() => this.open('showThemeModal')} data-target="#formModal">{translations.theme[selectedLanguage]}</a></li>
					<li><a href={undefined} data-toggle="modal" onClick={() => this.open('showAudioSettingsModal')} data-target="#formModal">{translations.audioSettings[selectedLanguage]}</a></li>
					<li role="separator" className="divider" />
					<li><a href={undefined} data-toggle="modal" onClick={() => this.open('showEditDetailsModal')} data-target="#formModal">{translations.personalData[selectedLanguage]}</a></li>
					<li><a href={undefined} data-toggle="modal" onClick={() => this.open('showChangePasswordModal')} data-target="#formModal">{translations.changePassword[selectedLanguage]}</a></li>
					{/* <li role="separator" className="divider" />
					<li className="logoutBtn"><a href={undefined} data-toggle="modal" onClick={this.handleLogout}>{translations.logout[selectedLanguage]}</a></li> */}
				</ul>

				<ChangeLanguageModal showModal={this.state.showModal} handleClose={() => this.close('showModal')} />
				<ThemeModal showThemeModal={this.state.showThemeModal} handleClose={() => this.close('showThemeModal')} />
				<EditPersonalDetailsModal showEditDetailsModal={this.state.showEditDetailsModal} handleClose={() => this.close('showEditDetailsModal')} />
				<EditRedirectModal showRedirectionModal={this.state.showRedirectionModal} handleClose={() => this.close('showRedirectionModal')} />
				<EditPanelModal showPanelSetupModal={this.state.showPanelSetupModal} handleClose={() => this.close('showPanelSetupModal')} />
				<ChangePassword showChangePasswordModal={this.state.showChangePasswordModal} handleClose={() => this.close('showChangePasswordModal')} />
				<AudioSettingsModal showModal={this.state.showAudioSettingsModal} handleClose={() => this.close('showAudioSettingsModal')}/>
			</li>
		);
	}
}

function mapStateToProps(state) {
	return {
		agentInfo: state.agentInfo,
		closeMenu: state.common.closeMenu,
		translations: state.languages.translations,
		selectedLanguage: state.languages.selectedLanguage,
		darkMode: state.common.darkMode,
		theme: state.common.theme,
	};
}

export default connect(mapStateToProps)(enhanceWithClickOutside(UserMenu));



// WEBPACK FOOTER //
// ./src/agent/user-menu.js